"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllianceCustomerInput = exports.AllianceCustomerCreateInput = exports.PortalCustomerTransport = exports.AllianceCustomerTransport = exports.DoNotServiceFlag = exports.DoNotServiceFlags = exports.PaymentSettingsTransport = exports.ExperienceDescriptor = exports.InvoiceIssueTerm = exports.InvoiceIssueTermLabels = exports.InvoiceIssueTerms = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const nullable_1 = require("../common/nullable");
const address_transport_1 = require("./address-transport");
const alliance_customer_contact_transport_1 = require("./alliance-customer-contact-transport");
const customer_type_1 = require("./customer-type");
const service_location_transport_1 = require("./service-location-transport");
exports.InvoiceIssueTerms = ['IMMEDIATE', 'MANUAL'];
exports.InvoiceIssueTermLabels = {
    IMMEDIATE: 'Immediate',
    MANUAL: 'Manual',
};
exports.InvoiceIssueTerm = typebox_1.Type.Union(exports.InvoiceIssueTerms.map((term) => typebox_1.Type.Literal(term)));
exports.ExperienceDescriptor = typebox_1.Type.Union([
    typebox_1.Type.Literal('Positive'),
    typebox_1.Type.Literal('Negative'),
    typebox_1.Type.Literal('Neutral'),
]);
exports.PaymentSettingsTransport = typebox_1.Type.Object({
    paymentMethod: typebox_1.Type.String(),
    paymentTerm: typebox_1.Type.String(),
    allowedPaymentMethod: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
});
exports.DoNotServiceFlags = ['MANUAL', 'CREDIT_LIMIT', 'IN_COLLECTIONS'];
exports.DoNotServiceFlag = typebox_1.Type.Union(exports.DoNotServiceFlags.map((flag) => typebox_1.Type.Literal(flag)));
exports.AllianceCustomerTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    customerNumber: typebox_1.Type.Number(),
    billingAddress: address_transport_1.AddressTransport,
    companyName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    channel: typebox_1.Type.String(),
    contacts: typebox_1.Type.Array(alliance_customer_contact_transport_1.AllianceCustomerContactTransport),
    credit: typebox_1.Type.Number(),
    experience: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
    overallExperience: typebox_1.Type.Optional((0, nullable_1.Nullable)(exports.ExperienceDescriptor)),
    notes: typebox_1.Type.String(),
    serviceLocations: typebox_1.Type.Array(service_location_transport_1.ServiceLocationTransport),
    stripeId: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    taxExempt: typebox_1.Type.Boolean(),
    chargeFullPrice: typebox_1.Type.Boolean(),
    displayName: typebox_1.Type.Optional(typebox_1.Type.String()),
    type: customer_type_1.CustomerType,
    motivation: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    businessType: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    reviewed: typebox_1.Type.Boolean(),
    leadID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    defaultPaymentSettings: exports.PaymentSettingsTransport,
    doNotService: typebox_1.Type.Boolean(),
    inCollections: typebox_1.Type.Boolean(),
    doNotServiceFlags: typebox_1.Type.Partial(typebox_1.Type.Record(exports.DoNotServiceFlag, typebox_1.Type.Boolean())),
    balanceLimit: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    balance: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    balanceLastUpdated: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    accountCreditLastUpdated: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    accountCredit: typebox_1.Type.Integer(),
    files: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    // account manager
    accountManagerID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    accountManagerName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    // account rep
    accountRepID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    accountRepName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    invoiceIssueTerm: exports.InvoiceIssueTerm,
    metadata: common_1.MetaData,
});
exports.PortalCustomerTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.AllianceCustomerTransport, [
        'metadata',
        'channel',
        'overallExperience',
        'experience',
        'notes',
        'type',
        'motivation',
        'businessType',
        'reviewed',
        'leadID',
        'doNotService',
        'invoiceIssueTerm',
        'files',
        'balance',
        'balanceLimit',
        'balanceLastUpdated',
        'doNotServiceFlags',
        'inCollections',
        'accountCreditLastUpdated',
    ]),
    typebox_1.Type.Object({
        paymentSources: typebox_1.Type.Array(typebox_1.Type.Object({
            id: typebox_1.Type.String(),
            brand: typebox_1.Type.String(),
            last4: typebox_1.Type.String(),
            expMonth: typebox_1.Type.Number(),
            expYear: typebox_1.Type.Number(),
            default: typebox_1.Type.Boolean(),
        })),
    }),
]);
exports.AllianceCustomerCreateInput = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.AllianceCustomerTransport, [
        'id',
        'contacts',
        'customerNumber',
        'metadata',
        'defaultPaymentSettings',
        'invoiceIssueTerm',
        'chargeFullPrice',
        'balance',
        'balanceLastUpdated',
        'doNotServiceFlags',
        'accountCredit',
        'accountCreditLastUpdated',
    ]),
    typebox_1.Type.Object({
        defaultPaymentSettings: typebox_1.Type.Optional(exports.PaymentSettingsTransport),
        invoiceIssueTerm: typebox_1.Type.Optional(exports.InvoiceIssueTerm),
        chargeFullPrice: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        contacts: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Omit(alliance_customer_contact_transport_1.AllianceCustomerContactTransport, ['id']))),
    }),
]);
exports.AllianceCustomerInput = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.AllianceCustomerTransport, [
        'contacts',
        'customerNumber',
        'metadata',
        'defaultPaymentSettings',
        'invoiceIssueTerm',
        'chargeFullPrice',
        'balance',
        'balanceLastUpdated',
        'doNotServiceFlags',
        'balanceLimit',
        'accountCredit',
        'accountCreditLastUpdated',
    ]),
    typebox_1.Type.Object({
        defaultPaymentSettings: typebox_1.Type.Optional(exports.PaymentSettingsTransport),
        invoiceIssueTerm: typebox_1.Type.Optional(exports.InvoiceIssueTerm),
        chargeFullPrice: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        balanceLimit: (0, nullable_1.Nullable)(typebox_1.Type.Optional(typebox_1.Type.Integer())),
        lastClosedOrderDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    }),
]));
//# sourceMappingURL=alliance-customer-transport.js.map